export const classificatonValues = ['S 公司级', 'A 跨部门', 'B 部门级']

export const classificatonOptions = classificatonValues.map((label, value) => ({
  label,
  value,
}))

export const classificationEnums = classificatonOptions.reduce(
  (acc, v) => ({
    ...acc,
    [v.value]: v.label,
  }),
  {} as any
)
